
import TableList from "@components/templates/tablelist";
import { HttpTruckList, HttpSubmitTruckOne, HttpCancelTruckOne, HttpStockInTruckOne, HttpCOpyTruckOne, HttpGetTruckNumber } from "@/service/bespeak";
import { mapState, mapGetters } from "vuex";
import comIndex from './update'
export default {
    mixins: [TableList],
    components: {
        comIndex,
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    'quanbu': 0,
                },
                isManage:0
            },
            exportdata:{},
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            spanTabs: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpTruckList,
        handleParams (params) {
            // 全部
            if (params.search.quanbu === 0) {
                params.search.EQ_status = null
            }

            if (params.search.caogao === 0) {
                params.search.EQ_status = 0
            }

            if (params.search.daixunjia === 0) {
                params.search.EQ_status = 1
            }

            else if (params.search.daiqueren === 0) {
                params.search.EQ_status = 2
            }

            else if (params.search.daituotou === 0) {
                params.search.EQ_status = 3
            }

            else if (params.search.yituotou === 0) {
                params.search.EQ_status = 4
            }

            else if (params.search.daishangchuanpod === 0) {
                params.search.EQ_status = 4
                params.search.EQ_isPod = 0
            }

            else if (params.search.yishangchuanpod === 0) {
                params.search.EQ_isPod = 1
            }
            if(params.search.EQ_shipType){
                params.shipType = params.search.EQ_shipType;
                delete params.search.EQ_shipType;
            }
            if(params.search.EQ_company){
                params.company = params.search.EQ_company;
                delete params.search.EQ_company;
            }
            // console.log(params,'paramsparamsparams')
            delete params.search.quanbu
            delete params.search.caogao
            delete params.search.daixunjia
            delete params.search.daiqueren
            delete params.search.daituotou
            delete params.search.yituotou
            delete params.search.daishangchuanpod
            delete params.search.yishangchuanpod
                // return params
            this.exportdata = params
            return params
        },
        interceptRequest(params) {
            return this.handleParams(params)
        },
        spanAjaxRequest: () => {
            return HttpGetTruckNumber({
                isManage: 0
            })
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'bespeakTruckClientUpdate',
                        params: { type: "add" },
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: 'bespeakTruckClientUpdate',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                case "query":
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 1200,
                        component: "comIndex",
                        activeids: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case "queryBlank":
                    var url = this.$router.resolve({
                        name: "bespeakTruckClientUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "submitbox":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('global.common.update_submit', { defaultValue: "提交" }),
                        width: 460,
                        params: { id: params },
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: this.$t('global.common.notes', { defaultValue: "备注" }),
                                required: false,
                            }
                        ],
                        ajaxRequest: HttpSubmitTruckOne
                    };
                    break;
                case "cancel":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('global.common.operate_cancel', { defaultValue: "取消" }),
                        width: 460,
                        params: { id: params },
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: this.$t('global.common.notes', { defaultValue: "备注" }),
                            }
                        ],
                        ajaxRequest: HttpCancelTruckOne,
                    };
                    break;
                case "copy":
                    this.operate = {
                        show: true,
                        alert: "info",
                        title: this.$t('fbb.inbound.copy_order', { defaultValue: '单据复制' }),
                        width: 460,
                        params: { id: params },
                        ajaxRequest: HttpCOpyTruckOne,
                    };
                    break;
                case "tuotou":
                    this.operate = {
                        show: true,
                        alert: "warning",
                        title: this.$t('fbb.headlogistics.tuotou', { defaultValue: '妥投' }),
                        width: 460,
                        params: { id: params },
                        formdata: [
                            {
                                tag: "vDatepicker",
                                key: "stockAt",
                                span: 24,
                                label: "妥投时间",
                                props:{
                                    format:'yyyy-mm-dd',
                                    confirm:false,
                                },
                            },
                        ],
                        ajaxRequest: HttpStockInTruckOne,
                    };
                    break;
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/truck/batchExport",
                    this.exportdata
                    , {
                        executor: 'request',
                        download: true,
                    }).catch(err => {
                        this.$VMessage.error(err.message);
                    })
                    break
            }
        },
        getOperateNodeMap(row) {
            const { id, status, orderType } = row
            return [
                {
                    label: this.$t('global.common.update_submit', { defaultValue: "提交" }),
                    show: (status == 0 ),
                    params: id,
                    operate: 'submitbox'
                },
                {
                    label: this.$t('global.common.query', { defaultValue: '查看' }),
                    show: true,
                    params: id,
                    operate: 'query'
                },
                {
                    label: this.$t('global.common.edit', { defaultValue: '编辑' }),
                    show: (status == 0),
                    params: id,
                    operate: 'edit'
                }, {
                    label: this.$t('global.common.operate_cancel', { defaultValue: '取消' }),
                    show: (status == 0 || status == 1 || status == 2 || status == 3) && this.handleAuth("fbb.truckReservation.cancel"),
                    params: id,
                    operate: 'cancel'
                },{
                    label: this.$t('fbb.inbound.copy_order', { defaultValue: '单据复制' }),
                    show: ((orderType == 1 || orderType == 2) && status == 5) || (orderType == 3 && (status == 3 || status == 4 || status == 5)),
                    params: id,
                    operate: 'copy'
                },{
                    label: this.$t('fbb.headlogistics.tuotou', { defaultValue: '妥投' }),
                    show: (status == 3) && this.handleAuth("fbb.truckReservation.stockIn"),
                    params: id,
                    operate: 'tuotou'
                },
            ]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getProductList', 'getSystemPortList', 'getCompanyList', 'getUserManageWarehouseList','getNextOrgList']),
        ...mapGetters("common", ["getStateList"]),
        getStatus(){
            return [
                {label:this.$t('fbb.headlogistics.draft', { defaultValue: '草稿' }),value:0},
                {label:this.$t('fbb.truck.makeinquiry', { defaultValue: "待询价" }),value:1},
                {label:this.$t('fbb.alloment.confirm', { defaultValue: "待确认" }),value:2},
                {label:this.$t('fbb.headlogistics.daituotou', { defaultValue: "待妥投" }),value:3},
                {label:this.$t('fbb.headlogistics.yituotou', { defaultValue: "已妥投" }),value:4},
                {label:this.$t('global.common.operate_cancel', { defaultValue: '取消' }),value:5},
            ]
        },
        TabsData() {
            return [
                {
                    name: this.$t('global.common.all', { defaultValue: '全部' }),
                    key: 'quanbu',
                    val: 0
                },
                {
                    name: this.$t('fbb.headlogistics.draft', { defaultValue: '草稿' }),
                    key: 'caogao',
                    val: 0,
                },
                {
                    name: this.$t('fbb.truck.makeinquiry', { defaultValue: "待询价" }),
                    key: 'daixunjia',
                    val: 0,
                    spanKey: "inquiryQty"
                },
                {
                    name: this.$t('fbb.alloment.confirm', { defaultValue: "待确认" }),
                    key: 'daiqueren',
                    val: 0
                },
                {
                    name: this.$t('fbb.headlogistics.daituotou', { defaultValue: "待妥投" }),
                    key: 'daituotou',
                    val: 0,
                    spanKey: "unStockQty"
                },
                {
                    name: this.$t('fbb.headlogistics.yituotou', { defaultValue: "已妥投" }),
                    key: 'yituotou',
                    val: 0
                },
                {
                    name: this.$t('fbb.truck.toupload', { defaultValue: "待上传" }) + 'POD',
                    key: 'daishangchuanpod',
                    val: 0
                },
                {
                    name: this.$t('fbb.headlogistics.uploaded', { defaultValue: "已上传" }) + 'POD',
                    key: 'yishangchuanpod',
                    val: 0,
                },
            ]
        },
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.add', { defaultValue: "添加" }),
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: this.$t('global.common.export', { defaultValue: '导出' }),
                    operate: 'export',
                    theme: 'success'
                },
            ]
        },
        SearchsData() {
            let widthStyle = 'width: 220px;'
            return [
                {
                    label: this.$t('fbb.truck.reserveNum', { defaultValue: "预约单号" }),
                    tag: 'vInput',
                    key: 'EQ_reservationNo',
                    show: true,
                },
                {
                    label: this.$t('fbb.headlogistics.transport_type', { defaultValue: "发运方式" }),
                    tag: 'vSelect',
                    key: 'EQ_shipType',
                    options: [
                        { value: 1, label: 'LTL' },
                        { value: 2, label: 'FTL' },
                    ],
                    props: {
                        filterable: true,
                    },
                    show: true,
                },
                {
                    label: this.$t('fbb.billDelivery.sourceNo', { defaultValue: "关联单号" })+'/'+this.$t('erp.b2c.search_ordernumber', { defaultValue: "订单号" }),
                    tag: 'vInput',
                    key: 'CN_linkedNo',
                    show: true,
                },
                {
                    label: this.$t('global.common.deliveryWarehouse', { defaultValue: "发货仓库" }),
                    tag: 'Select',
                    key: 'EQ_orgWarehouseId',
                    options: this.getUserManageWarehouseList.map(item=>{
                        return {
                            value:item.attach.id,
                            label:item.label
                        }
                    }),
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.alloment.order_type', { defaultValue: "单据类型" }),
                    tag: 'Select',
                    options: [
                        { label: 'B2B', value: 1},
                        { label: 'B2C', value: 2},
                        { label: 'other ', value: 3},
                        { label: 'transport ', value: 4},
                    ],
                    key: 'EQ_orderType',
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.truck.company', { defaultValue: "卡车公司" }),
                    tag: 'vInput',
                    key: 'EQ_company',
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.designated_person', { defaultValue: "负责人" }),
                    tag: 'vInput',
                    key: 'EQ_createdName',
                    style: widthStyle
                },
                {
                    label: this.$t('global.common.status ', { defaultValue: "状态" }),
                    tag: 'Select',
                    key: 'IN_status',
                    options: this.getStatus,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.truck.billlading', { defaultValue: "提单状态" }),
                    tag: 'Select',
                    key: 'EQ_isBol',
                    options: [
                        {value:0,label:this.$t('fbb.headlogistics.unupload', { defaultValue: "未上传" })},
                        {value:1,label:this.$t('fbb.headlogistics.uploaded', { defaultValue: "已上传" })},
                    ],
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
					label: this.$t('fbb.alloment.ship_to_state',{defaultValue:'目的地州/省份'}),
                    tag: 'Select',
                    key: 'EQ_shipToState',
                    options: this.getStateList.map(item => {
                        return {
                          value: item,
                          label: item
                        }
                      }),
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },                {
					label: this.$t('fbb.alloment.ship_to_city',{defaultValue:'目的地城市'}),
                    tag: 'vInput',
                    key: 'EQ_shipToCity',
                },
                {
                    label: this.$t('fbb.alloment.client_organization',{defaultValue:'客户'}),
                    tag: 'Select',
                    key: 'EQ_orgId',
                    options: this.getNextOrgList,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('global.common.update_time', { defaultValue: '更新时间' }),
                    tag: 'vDatepicker',
                    key: 'BT_updatedAt',
                    style: "width:180px",
                    props:{
                        format:'yy-mm-dd ~ yy-mm-dd',
                        confirm:false,
                    },
                    style: widthStyle
                }

            ]
        },
        columns() {
            return [
                {
                    show: false,
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id',
                }, {
                    title: this.$t('global.common.operation', { defaultValue: '操作' }),
                    width: 70,
                    render: this.getOperateNodes,
                }, {
                    title: this.$t('fbb.truck.reserveNum', { defaultValue: '预约单号' }),
                    sortable: true,
                    render: (h, { row }) => {
                        return <div>
                            <div>
                                <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.reservationNo || '--'}</a>
                                <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                            </div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.alloment.order_status', { defaultValue: "单据状态" })+'/'+this.$t('fbb.truck.billlading', { defaultValue: "提单状态" }),
                    width: 90,
                    render: (h, { row }) => {
                        return <div>
                            <div>{this.findRenderLabel(this.getStatus, row.status)}</div>
                            <div>{row.isBol == 1 ? this.$t('fbb.headlogistics.uploaded', { defaultValue: "已上传" }) : this.$t('fbb.headlogistics.unupload', { defaultValue: "未上传" })}</div>
                        </div>
                    },
                },
                {
                    title: this.$t('fbb.headlogistics.transport_type', { defaultValue: "发运方式" }),
                    key:'shipType',
                    render: (h, { row }) => {
                        return <div>
                            {row.shipType == 1 ? 'LTL' : row.shipType == 2 ? 'FTL' : ''}
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.billDelivery.sourceNo', { defaultValue: "关联单号" }) + '/' + this.$t('erp.b2c.search_ordernumber', { defaultValue: "订单号" }),
                    key:'linkedNo',
                },
                {
                    title: this.$t('global.common.deliveryWarehouse', { defaultValue: "发货仓库" }),
                    key:'orgWarehouseCode',
                },
                {
                    title: this.$t('fbb.truck.company', { defaultValue: "卡车公司" }),
                    key:'company',
                },
                // {
                //     title:'BOL',
                //     key:'billNo',
                // },
                {
                    title: this.$t('fbb.truck.deliverytime', { defaultValue: "提货时间" }),
                    key:'pickUpAt'
                },
                {
                    title: this.$t('fbb.truck.warehousetime', { defaultValue: "送仓时间" }),
                    sortable: true,
                    key:'deliveryAt',
                },
                {
                    title: this.$t('fbb.expresspackage.delivered_at', { defaultValue: "妥投时间" }),
                    sortable: true,
                    key:'actualStockAt',
                },

                {
                    title: this.$t('fbb.headlogistics.designated_person', { defaultValue: '负责人' }),
                    key: 'createdName',
                },
                {
                    title: this.$t('global.common.update_time', { defaultValue: '更新时间' }),
                    key: 'updatedAt',
                    width: 180,
                },
            ];
        },

    },

};
